module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tcc4Km/tc-custom/9781526748058.jpg?1721404537890",
      "alt": "This image is the cover for the book Kamikaze"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kamikaze\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This enlightening WWII history examines Japans Kamikaze Corps of special forces pilots who engaged in terrifying suicide attacks.")]), _c('br'), _c('br'), _vm._v("By late 1944, the Japanese had already proved themselves fanatical in their quest for victory. But the actions of the Kamikaze Corps took matters to a new level. Western military forces were dumbfounded by an enemy strategy of deliberate self-sacrifice."), _c('br'), _c('br'), _vm._v("Beginning with the Leyte Gulf battle, Kamikaze attacks continued during the invasion of the Philippines in early 1945 and reached a climax during the months-long Battle of Okinawa. In total, more than a thousand kamikaze airmen perished."), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Kamikaze")]), _vm._v(", historian Adrian Stewart examines the historic and cultural roots of the unique and unsettling phenomenon. He also provides graphic descriptions of these suicide attacks and their devastating impact on Allied forces.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adrian Stewart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Adrian Stewart was educated at Rugby School before taking First Class Honours at Caius College, Cambridge. His previously published works with Pen and Sword Books include: Eighth Army’s Greatest Victories, Early Battles of Eighth Army, They Flew Hurricanes, The Campaigns of Alexander of Tunis 1940-1945, February 1942 – Britain’s Darkest Days, Carriers at War, Six of Monty’s Men and Ten Squadrons of Hurricanes (2015) have all been published by Pen and Sword Books. He lives near Rugby.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Aviation\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0